import React from 'react';
import {
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Button,
  Divider,
  Card,
  CardContent,
  Typography,
  Box,
} from '@mui/material';
import { FileText } from 'lucide-react';
import { Report } from './types';

interface ReportsListProps {
  reports: Report[];
  onReportClick: (report: Report) => void;
  isMobile: boolean;
}

export const ReportsList: React.FC<ReportsListProps> = ({
  reports,
  onReportClick,
  isMobile,
}) => {
  if (isMobile) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {reports.map((report) => (
          <Card key={report.id}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 2 }}>
                <Box sx={{ 
                  p: 1, 
                  borderRadius: 1, 
                  bgcolor: 'primary.main',
                  color: 'primary.contrastText',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  {report.icon}
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 0.5 }}>
                    {report.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {report.description}
                  </Typography>
                </Box>
              </Box>
              <Button
                variant="outlined"
                startIcon={<FileText size={16} />}
                onClick={() => onReportClick(report)}
                fullWidth
              >
                Generate Report
              </Button>
            </CardContent>
          </Card>
        ))}
      </Box>
    );
  }

  return (
    <Paper>
      <List>
        {reports.map((report, index) => (
          <React.Fragment key={report.id}>
            <ListItem>
              <ListItemIcon sx={{ color: 'primary.main' }}>
                {report.icon}
              </ListItemIcon>
              <ListItemText
                primary={report.title}
                secondary={report.description}
                primaryTypographyProps={{
                  fontWeight: 500,
                }}
              />
              <Button
                variant="outlined"
                size="small"
                startIcon={<FileText size={16} />}
                onClick={() => onReportClick(report)}
              >
                Generate Report
              </Button>
            </ListItem>
            {index < reports.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </List>
    </Paper>
  );
};